let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("n0OuE")).then(() => parcelRequire('dLXOY'));